export default __webpack_public_path__ + "static/OxbloodOrig-5b994259b36c545fed31d0cb741ab46c.jpg";